<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Unauffällig sicher oder markant gestaltet</h2>
        <div class="flex justify-center">
          <h1 class="headline">Fenstergitter</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Sicherheit am Haus muss nicht auffallen, kann es aber. Unsere Fenstergitter verbinden Schutz mit Stil und lassen sich genauso schlicht oder ausdrucksstark gestalten, wie es zur Fassade passt.
        </p>

        <p class="mt-4 text-gray-700">
          Ob klassisch-geradlinig, verschnörkelt oder mit individuellen Designelementen – jedes Gitter wird von uns maßgefertigt und präzise montiert. Die Ausführung erfolgt je nach Wunsch in verzinktem Stahl, farbig pulverbeschichtet oder aus hochwertigem Edelstahl, stets witterungsbeständig und langlebig.
        </p>

        <p class="mt-4 text-gray-700">
          So entsteht nicht nur ein sicheres Zuhause, sondern auch ein harmonischer Gesamteindruck, abgestimmt auf Architektur und Anspruch.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Fenstergitter" pixelEvent="FormFenstergitterSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/fenstergitter/1.jpg", alt: "Fenstergitter 1" },
        { src: "img/produkte/fenstergitter/2.jpg", alt: "Fenstergitter 2" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
